import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'

export const QBR_DOCUMENT_SAVE_AS_CONFIRM_IDENTIFIER: ConfirmDialogIdentifier =
  'QbrDocumentSaveAsConfirm'
